import React from "react";

const SoftAbout = () => {
  const brandCyan = "#0ea5e9";
  const brandPurple = "#d946ef";

  return (
    <div
      style={{
        fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif",
        color: "#1e293b",
        backgroundColor: "#ffffff",
        padding: "50px 0 70px",
        marginTop: "-50px",
      }}
    >
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 20px" }}>
        {/* ================= 1. Header / Hero Section ================= */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "50px",
            alignItems: "center",
            marginBottom: "70px",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                letterSpacing: "1.2px",
                marginBottom: "10px",
                textTransform: "uppercase",
              }}
            >
              ✦ INNOVATION & EXCELLENCE
            </div>

            <h2
              style={{
                fontSize: "36px",
                lineHeight: "1.25",
                fontWeight: "800",
                color: "#0f172a",
                margin: "0 0 18px 0",
              }}
            >
              Empowering Businesses via{" "}
              <span style={{ color: brandPurple }}>Digital Transformation</span>
            </h2>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "20px",
              }}
            >
              <strong style={{ color: brandCyan }}>Iconic Soft Ltd.</strong> is
              the software and technology flagship of Iconic Unity Group. We
              specialize in building scalable, high-performance web
              applications, mobile platforms, and enterprise automation tools
              tailored to drive business success.
            </p>

            <p
              style={{
                color: "#64748b",
                lineHeight: "1.65",
                fontSize: "15px",
                marginBottom: "28px",
              }}
            >
              From ambitious startups to modernizing enterprises, our
              engineering-first approach ensures robust architecture, seamless
              user experience, and forward-looking tech stacks.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "14px",
              }}
            >
              {[
                "Agile Software Development",
                "Cloud-Native Solutions",
                "User-Centric UI/UX Design",
                "24/7 Enterprise Support",
              ].map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#334155",
                  }}
                >
                  <span
                    style={{
                      color: brandPurple,
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                  >
                    ✓
                  </span>{" "}
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div style={{ position: "relative" }}>
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=85"
              alt="Tech Team Collaboration"
              style={{
                width: "100%",
                height: "380px",
                borderRadius: "16px",
                objectFit: "cover",
                display: "block",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-20px",
                left: "-20px",
                background: "#ffffff",
                padding: "16px 24px",
                borderRadius: "12px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid #f1f5f9",
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "800",
                  color: brandCyan,
                  display: "block",
                  lineHeight: "1",
                }}
              >
                99.8%
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                Client Satisfaction Rate
              </span>
            </div>
          </div>
        </div>

        {/* ================= 2. Stats Section ================= */}
        <div
          style={{
            background: "#f8fafc",
            padding: "32px 24px",
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginBottom: "70px",
            textAlign: "center",
          }}
        >
          {[
            { value: "150+", label: "Projects Delivered" },
            { value: "50+", label: "Tech Experts" },
            { value: "10+", label: "Industries Served" },
            { value: "99.9%", label: "Uptime Guaranteed" },
          ].map((stat, i) => (
            <div key={i}>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: "800",
                  color: brandPurple,
                  display: "block",
                  lineHeight: "1.1",
                  marginBottom: "4px",
                }}
              >
                {stat.value}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#64748b",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* ================= 3. What We Do ================= */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: brandPurple,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            OUR EXPERTISE
          </span>

          <h2
            style={{
              fontSize: "32px",
              fontWeight: "800",
              margin: "8px 0 36px 0",
              color: "#0f172a",
            }}
          >
            Solutions We <span style={{ color: brandCyan }}>Deliver</span>
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
              gap: "16px",
            }}
          >
            {[
              "Custom Software Development",
              "Web Application Development",
              "Mobile App Development",
              "ERP & CRM Solutions",
              "Business Process Automation",
              "Cloud & DevOps Solutions",
              "API & Systems Integration",
              "UI/UX Design & Prototyping",
              "IT & Tech Consulting",
              "Software Quality Assurance",
              "Digital Transformation",
              "AI & Machine Learning",
            ].map((service, index) => (
              <div
                key={index}
                style={{
                  padding: "18px 16px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  background: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#334155",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: brandCyan,
                    display: "inline-block",
                  }}
                />
                {service}
              </div>
            ))}
          </div>
        </div>

        {/* ================= 4. Core Values ================= */}
        <div style={{ marginBottom: "70px" }}>
          <div style={{ textAlign: "center", marginBottom: "36px" }}>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: brandCyan,
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              WHY CHOOSE US
            </span>

            <h2
              style={{
                fontSize: "32px",
                fontWeight: "800",
                margin: "8px 0 0 0",
                color: "#0f172a",
              }}
            >
              Built for{" "}
              <span style={{ color: brandPurple }}>Growth & Reliability</span>
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
            }}
          >
            {[
              {
                title: "Scalable Architecture",
                desc: "We write clean, modular, and maintainable code built to scale seamlessly as your user base grows.",
              },
              {
                title: "Security-First Mindset",
                desc: "Data protection and encryption are baked into every layer of our software engineering life cycle.",
              },
              {
                title: "Agile Execution",
                desc: "Rapid sprint iterations with complete visibility, ensuring faster time-to-market without compromises.",
              },
            ].map((val, idx) => (
              <div
                key={idx}
                style={{
                  background: "#f8fafc",
                  padding: "28px 24px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px 0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#0f172a",
                  }}
                >
                  {val.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "14px",
                    color: "#64748b",
                    lineHeight: "1.6",
                  }}
                >
                  {val.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 5. Process Steps ================= */}
        <div style={{ textAlign: "center", marginBottom: "70px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: "700",
              color: brandCyan,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            OUR METHODOLOGY
          </span>

          <h2
            style={{
              fontSize: "32px",
              fontWeight: "800",
              margin: "8px 0 36px 0",
              color: "#0f172a",
            }}
          >
            Development <span style={{ color: brandPurple }}>Process</span>
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: "16px",
            }}
          >
            {[
              "Discovery",
              "Requirements",
              "UI/UX Design",
              "Development",
              "QA & Testing",
              "Deployment",
              "Support",
            ].map((step, idx) => (
              <div
                key={idx}
                style={{
                  background: "#ffffff",
                  padding: "22px 14px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.02)",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: brandCyan,
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 12px auto",
                    fontWeight: "800",
                    fontSize: "14px",
                  }}
                >
                  {idx + 1}
                </div>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#0f172a",
                    display: "block",
                  }}
                >
                  {step}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* ================= 6. Bottom Banner / CTA ================= */}
        <div
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #d946ef 100%)",
            padding: "40px",
            borderRadius: "16px",
            color: "#ffffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "26px",
                fontWeight: "800",
                color: "#ffff",
              }}
            >
              Have a Project in Mind?
            </h3>
            <p style={{ margin: 0, fontSize: "15px", opacity: 0.95 }}>
              Let's build scalable digital solutions tailored for your
              enterprise.
            </p>
          </div>

          <div style={{ display: "flex", gap: "14px" }}>
            <button
              style={{
                background: "#ffffff",
                color: "#0f172a",
                border: "none",
                padding: "14px 26px",
                borderRadius: "8px",
                fontWeight: "700",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Get Free Consultation →
            </button>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            div[style*="gridTemplateColumns: 1fr 1fr"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="gridTemplateColumns: repeat(4, 1fr)"] {
              grid-template-columns: repeat(2, 1fr) !important;
            }
            div[style*="gridTemplateColumns: repeat(3, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
          }

          @media (max-width: 640px) {
            div[style*="gridTemplateColumns: repeat(4, 1fr)"],
            div[style*="gridTemplateColumns: repeat(2, 1fr)"] {
              grid-template-columns: 1fr !important;
            }
            div[style*="justifyContent: space-between"] {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
            h2 {
              font-size: 28px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SoftAbout;
